/**
 * @fileoverview Error handling utility that redirects to appropriate error pages.
 * @module helpers/catchRedirect
 */

import router from "@/router";

/**
 * Handles API errors by redirecting to appropriate error pages.
 *
 * Redirects based on error type:
 * - 401 (Unauthorized): Redirects to session-timeout page
 * - 403 (Forbidden): Redirects to no-permission page
 * - Network errors: Redirects to connection-error page
 *
 * @param {Object} error - The error object from API call
 * @param {Object} [error.networkError] - Network-level error (GraphQL)
 * @param {number} [error.networkError.statusCode] - HTTP status code
 * @param {Object} [error.response] - Response object (Axios)
 * @param {number} [error.response.status] - HTTP status code
 * @returns {void}
 *
 * @example
 * try {
 *   await api.fetchData();
 * } catch (error) {
 *   catchRedirect(error);
 * }
 */
export default function catchRedirect(error: any) {
  if (error.networkError && error.networkError.statusCode === 401) {
    router.push({ path: "/error/session-timeout" }).catch(() => {});
  } else if (
    (error.networkError && error.networkError.statusCode === 403) ||
    (error.response && error.response.status === 403) ||
    (error.response && error.response.status === 401)
  ) {
    router.push({ path: "/error/no-permission" }).catch(() => {});
  } else if (error.networkError) {
    router.push({ path: "/error/connection-error" }).catch(() => {});
  }
}
